import axios from 'axios';
import Vue from 'vue';
import store from '../store/index';
const XHR_REQUEST_HEADER_PARAM_NAME = 'X-Requested-With';
const XHR_REQUEST_HEADER_PARAM_VALUE = 'XMLHttpRequest';
import { errorNotification } from '../shared/notificaitons';
const instance = axios.create({
  baseURL: '/api/v1.0/',
  timeout: 40000,
});
instance.interceptors.request.use(config => {
  store.commit('loading', true);
  return config;
});

// Interceptor on all requests
instance.interceptors.request.use(
  config => {
    config.headers = {
      ...config.headers,
      [XHR_REQUEST_HEADER_PARAM_NAME]: XHR_REQUEST_HEADER_PARAM_VALUE,
    };
    return config;
  },
  error => {
    store.commit('loading', false);
    Vue.$log.error('Errror ' + error);

    errorNotification(`Error:${error.message}`);
    return Promise.reject(error);
  }
);

// Interceptor on all responses
instance.interceptors.response.use(
  response => {
    store.commit('loading', false);
    return response;
  },
  error => {
    store.commit('loading', false);
    Vue.$log.error('Error ' + error);
    errorNotification(`Error:${error.message}`);

    return Promise.reject(error);
  }
);

export async function searchRequest(searchRequest) {
  const request = encodeURIComponent(searchRequest);
  return instance.get(`search?query=${request}`);
}
